<template>
  <edit-sheet-real
    v-if="show"
    @reset="reset"
    :dispatchId="dispatchId"
    :loadOrderId="loadOrderId"
    :canEdit="true"
  ></edit-sheet-real>
</template>

<script>
import EditSheetReal from "./editSheetReal.vue";
export default {
  components: {
    EditSheetReal,
  },
  props: {
    loadOrderId:{

    },
    dispatchId:{

    }
  },
  data() {
    return {
      show: true,
    };
  },
  methods: {
    async reset() {
      this.show = false;
      await this.$nextTick();
      this.show = true;
    },
  },
};
</script>

<style>
</style>